import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class SurveyObjective extends BaseService {
  constructor() {
    super("survey-objectives");
  }

  /**
   *
   * @param {string} respondent
   * @param {string} enterpriseId
   * @param {{criterias?: string[]}} params
   * @returns
   */
  getByRespondent(respondent, enterpriseId, params = {}) {
    return getResponseQuery(
      http.get(`${this.path}/get-by-respondent/${respondent}/${enterpriseId}`, {
        params
      })
    );
  }

  /**
   *
   * @param {string} surveyRequestId
   * @param {{criterias?: string[]}} params
   * @returns
   */
  getBySurveyRequest(surveyRequestId, params = {}) {
    return getResponseQuery(
      http.get(`${this.path}/get-by-survey-request/${surveyRequestId}`, {
        params
      })
    );
  }

  /**
   *
   * * @param {string} respondent
   * @param {string[]} surveySubjects
   * @returns
   */
  getBySurveySubjects(respondent, surveySubjects) {
    let params = {
      surveySubjects
    };

    return getResponseQuery(
      http.get(`${this.path}/get-by-survey-subjects/${respondent}`, {
        params
      })
    );
  }
}

export default new SurveyObjective();
